// Formats an ISO `YYYY-MM-DD` date string for display, e.g. "Oct 24, 2021".
// Uses UTC so the day never shifts due to the viewer's timezone.
export default function formatDate (iso) {
    if (!iso) return ''
    const [y, m, d] = String(iso).split('-').map(Number)
    if (!y || !m || !d) return iso
    return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
    })
}
